import React, { memo, useEffect, useState } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { FormattedMessage, useIntl } from 'react-intl'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import Link from 'next/link'
import { parseFiltersToUrl } from 'filters'
import Page from 'components/layout/Page'
import usePageProps from 'hooks/usePageProps'
import { useQuery } from 'react-query'
import axios from 'axios'
import { Skeleton } from '@mui/material'
import { titleCaps } from 'utils/universal'

const sx = {
  container: {
    mb: 3,
  },

  card: {
    height: '100%',
    '& a': {
      color: 'inherit',
    },
  },

  cardContent: {
    height: 180,
    overflow: 'scroll',
  },
}

const MakeCard = ({ make, enabled = false }) => {
  const { data, status } = useQuery([make], () => axios(`${process.env.NEXT_PUBLIC_API_ROOT}/api/filters/models?maker=${make}`), { enabled })
  const { formatMessage: f } = useIntl()
  const basePath = f({ id: 'ROUTE_SEARCH' })
  return (
    <Card
      elevation={4}
      sx={sx.card}
    >
      <CardHeader title={(
        <Typography
          component="h2"
          variant="h2"
        >
          <Link
            href={`${basePath}${(parseFiltersToUrl({ maker: make })).toLowerCase()}`}
            passHref
          >
            {titleCaps(make)}
          </Link>
        </Typography>
      )}
      />
      <CardContent sx={sx.cardContent}>
        {(status === 'loading' || status === 'idle') && [1, 2, 3, 4, 5].map(() => (
          <Skeleton variant="text" />
        ))}

        {data?.data?.map((model) => (
          <Typography
            key={`${make}-${model.name}`}
            variant="h3"
            component="h3"
            color="text.primary"
            gutterBottom
          >
            <Link
              href={`${basePath}${(parseFiltersToUrl({ maker: make, model: model.name })).toLowerCase()}`}
              passHref
            >
              {titleCaps(`${make} ${model.name}`)}
            </Link>
          </Typography>
        ))}
      </CardContent>
    </Card>

  )
}

const Sitemap = () => {
  const { makes } = usePageProps()

  const [counter, setCounter] = useState(-1)

  // Workaround fort the cache issue with the API
  useEffect(() => {
    if (counter > makes.length) return

    const counterInterval = setInterval(() => {
      setCounter(counter + 1)
    }, 50)

    return () => {
      clearInterval(counterInterval)
    }
  }, [counter, makes])

  return (
    <Page>
      <Container
        maxWidth="md"
        sx={sx.container}
      >
        <Typography
          variant="h1"
          align="center"
          sx={{ marginTop: 3, marginBottom: 5 }}
        >
          <FormattedMessage id="SITEMAP_H1" />
        </Typography>

        <Grid
          container
          spacing={2}
        >
          {makes.map((make, i) => (
            <Grid
              key={i}
              size={{
                xs: 6,
                md: 4,
              }}
            >
              <MakeCard
                make={make.name}
                enabled={i === counter}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Page>
  )
}

export default memo(Sitemap)
